import React from "react";

const OtherSkills = () => {
  return (
    <section>
      <figure>
        <svg
          enableBackground="new 0 0 512 512"
          version="1.1"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m146.8 286c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10z" />
          <path d="m146.8 326c-5.523 0-10 4.477-10 10v126c0 5.523 4.477 10 10 10s10-4.477 10-10v-126c0-5.523-4.478-10-10-10z" />
          <path d="m424.19 7.516c-0.824-3.215-3.19-5.812-6.314-6.931-3.125-1.118-6.601-0.615-9.278 1.345-9.993 7.315-60.255 44.942-68.442 67.424-4.867 13.391-3.761 28.008 2.773 40.39-12.26 17.586-24.959 41.868-36.135 65.593v-165.34c0-5.523-4.478-10-10-10h-80c-5.523 0-10 4.477-10 10v196h-1.795l-17.08-66.449c-8e-3 -0.033-0.017-0.066-0.026-0.099l-15.53-57.95c-1e-3 -2e-3 -1e-3 -4e-3 -2e-3 -6e-3 -0.09-0.333-0.199-0.661-0.323-0.984-0.038-0.099-0.084-0.194-0.125-0.292-0.094-0.225-0.192-0.447-0.303-0.665-0.054-0.106-0.113-0.208-0.171-0.312-0.113-0.205-0.232-0.407-0.36-0.604-0.065-0.099-0.132-0.196-0.2-0.293-0.137-0.195-0.281-0.384-0.432-0.57-0.042-0.051-0.076-0.107-0.119-0.157l-59.34-69.92c-2.484-2.927-6.424-4.173-10.139-3.208s-6.55 3.972-7.295 7.738l-17.93 90.62c-0.013 0.067-0.016 0.135-0.028 0.201-0.046 0.261-0.084 0.522-0.109 0.784-0.011 0.111-0.018 0.222-0.025 0.333-0.015 0.25-0.021 0.498-0.018 0.747 1e-3 0.116 2e-3 0.232 8e-3 0.348 0.012 0.255 0.037 0.508 0.069 0.761 0.013 0.104 0.021 0.207 0.037 0.31 0.055 0.353 0.125 0.702 0.217 1.047l15.512 57.892 10.406 41.166c-6.07 1.035-11.665 3.905-16.11 8.35-5.667 5.668-8.789 13.201-8.789 21.211 0 13.036 8.361 24.152 20 28.28v197.72c0 27.57 22.43 50 50 50h200c27.57 0 50-22.43 50-50v-197.7c4.168-1.471 7.991-3.866 11.211-7.085 5.668-5.668 8.789-13.201 8.789-21.211 0-14.612-10.504-26.811-24.356-29.46 6.523-26.504 11.121-52.843 12.818-73.509 13.35-5.163 23.88-15.762 28.875-29.48 8.203-22.526-6.841-83.95-9.941-96.035zm-67.955 118.24c4.135 3.253 8.78 5.852 13.808 7.682 4.806 1.749 9.801 2.741 14.824 2.971-2.005 19.938-6.599 44.761-12.911 69.592h-57.164c15.271-34.604 29.376-61.908 41.443-80.245zm-129.44-105.76h60v23h-20c-5.522 0-10 4.477-10 10s4.478 10 10 10h20v20h-20c-5.522 0-10 4.477-10 10s4.478 10 10 10h20v20h-20c-5.522 0-10 4.477-10 10s4.478 10 10 10h20v20h-20c-5.522 0-10 4.477-10 10s4.478 10 10 10h20v23h-60v-186zm-117.64 16.443l41.027 48.342c-6.167 7.791-14.635 13.379-24.41 15.997-9.737 2.609-19.822 2.017-29.028-1.61l12.411-62.729zm-9.023 84.551c4.43 0.928 8.942 1.403 13.479 1.403 5.781 0 11.602-0.76 17.336-2.296 10.238-2.742 19.46-7.778 27.134-14.647l10.486 39.127 15.787 61.419h-62.139l-11.552-45.701c-0.011-0.046-0.023-0.092-0.036-0.137l-10.495-39.168zm276.67 341.01c0 16.542-13.458 30-30 30h-200c-16.542 0-30-13.458-30-30v-196h260v196zm20-226c0 2.668-1.041 5.179-2.931 7.068-1.891 1.891-4.401 2.932-7.069 2.932h-280c-5.514 0-10-4.486-10-10 0-2.668 1.041-5.179 2.931-7.068 1.891-1.891 4.401-2.932 7.069-2.932h90.385c0.02 0 0.039 2e-3 0.058 2e-3 0.013 0 0.026-2e-3 0.039-2e-3h102.22c0.016 0 0.033 2e-3 0.049 2e-3 0.011 0 0.022-2e-3 0.034-2e-3h80.07c0.012 0 0.025 2e-3 0.037 2e-3 0.02 0 0.039-2e-3 0.059-2e-3h7.046c5.512 0 9.999 4.486 9.999 10zm18.543-139.29c-3.529 9.692-11.659 16.809-21.771 19.041-5.533 1.234-11.301 0.851-16.682-1.106-5.575-2.03-10.374-5.62-13.876-10.379-1e-3 -2e-3 -3e-3 -4e-3 -4e-3 -6e-3 -5.978-8.113-7.492-18.607-4.055-28.066 3.748-10.292 28.141-32.238 49.371-48.931 5.84 26.538 10.758 59.174 7.017 69.447z" />
        </svg>
      </figure>
      <div>
        <h4>Other Skills</h4>
        <article className="skill-list">
          <p>
            English:
            <span className="skill">
              <i />
              <i />
              <i />
            </span>
          </p>

          <p>
            UX Design:
            <span className="skill">
              <i />
            </span>
          </p>

          <p>
            UI Design:
            <span className="skill">
              <i />
              <i />
            </span>
          </p>
        </article>
      </div>
    </section>
  );
};

export default OtherSkills;
